import "./src/styles/global.css";
// https://github.com/FormidableLabs/prism-react-renderer#custom-language-support
// https://github.com/PrismJS/prism/tree/master/components
import { Prism } from 'prism-react-renderer';
(typeof global !== "undefined" ? global : window).Prism = Prism;
require('prismjs/components/prism-python');
require('prismjs/components/prism-json');
